/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindHomeHealthPractitionerAssignments200ResponseData } from './FindHomeHealthPractitionerAssignments200ResponseData';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataToJSON,
} from './FindHomeHealthPractitionerAssignments200ResponseData';

/**
 *
 * @export
 * @interface FindHomeHealthPractitionerAssignments200Response
 */
export interface FindHomeHealthPractitionerAssignments200Response {
    /**
     *
     * @type {FindHomeHealthPractitionerAssignments200ResponseData}
     * @memberof FindHomeHealthPractitionerAssignments200Response
     */
    data: FindHomeHealthPractitionerAssignments200ResponseData;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200Response interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function FindHomeHealthPractitionerAssignments200ResponseFromJSON(json: any): FindHomeHealthPractitionerAssignments200Response {
    return FindHomeHealthPractitionerAssignments200ResponseFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': FindHomeHealthPractitionerAssignments200ResponseDataFromJSON(json['data']),
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseToJSON(value?: FindHomeHealthPractitionerAssignments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': FindHomeHealthPractitionerAssignments200ResponseDataToJSON(value.data),
    };
}
